import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useAuth } from "../context/global";

const Auth: React.FC = () => {
    const { handleGetToken, handleSaveAuth } = useAuth();
    const azureAuth = process.env.REACT_APP_REDIRECT_LOGIN || "";
    const url = window.location.href;

    function paramsToObject(entries: any) {
        const result: Record<string, any> = {};
        for (const [key, value] of entries) {
            result[key] = value;
        }
        return result;
    }

    function getParams(hashUrl: any) {
        const scheme = new URL(hashUrl);
        const query = scheme.hash.replace(/^#/gi, "");
        const queryParams = new URLSearchParams(query);
        return paramsToObject(queryParams.entries());
    }

    const dados = getParams(url);

    useEffect(() => {
        (async () => {
            const res = await handleGetToken();

            if (!res && Object.keys(dados).length > 0) {
                handleSaveAuth(dados);
            }

            const isAuth = await handleGetToken();
            
            if (!isAuth) {
                if (azureAuth) {
                    window.location.href = azureAuth;
                }
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [azureAuth]);

    return (
        <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <Typography variant="h6">Login Pré-billing</Typography>
        </Box>
    );
};

export default Auth;
